import { createReducer } from 'deox';
import { Paging, Country } from '@/types';
import {
  fetchRegionsActions,
  fetchCountriesByRegionActions,
  fetchCurrenciesActions
} from '@/redux/actions/country-information';

export interface RegionsState {
  regions: {
    data?: {
      label: string;
      value: string;
    }[];
    paging: Paging;
  };
  countries: {
    data?: {
      label: string;
      value: string;
      code: string;
    }[];
    paging: Paging;
    meta: {
      authors: string[];
    };
  };
  currencies:{
    data?:{
      name: string;
      code: string;
      symbol: string;
      decimals: number;
      displaySymbol: string;
      displayFormat: string;
      displaySymbolFirst: boolean;
      isoCode: string;
      displaySpace: number;
      logo: string;
    }[];
    paging: Paging;
  }
}

const initialState: RegionsState = {
  regions: {
    data: undefined,
    paging: {
      pageNumber: 0,
      pageSize: 0,
      totalRecords: 0,
    },
  },
  countries: {
    data: undefined,
    paging: {
      pageNumber: 0,
      pageSize: 0,
      totalRecords: 0,
    },
    meta: {
      authors: [],
    },
  },
  currencies: {
    data: undefined,
    paging: {
      pageNumber: 0,
      pageSize: 999,
      totalRecords: 0,
    },
  },
};

const countryInformationRegionsReducer = createReducer(initialState, (handleAction) => [
  handleAction(fetchRegionsActions.success, (state, { payload }) => {
    const { data, paging } = payload;
    const beautifyRegions = data.map((region) => ({ label: region, value: region }));
    return {
      ...state,
      regions: {
        data: beautifyRegions,
        paging,
      },
    };
  }),
  handleAction(fetchCurrenciesActions.success, (state, { payload }) => {
    const { data, paging } = payload;
    return {
      ...state,
      currencies: {
        data,
        paging,
      },
    };
  }),
  handleAction(fetchCountriesByRegionActions.success, (state, { payload }) => {
    const { data, paging, meta } = payload;
    const beautifyCountries = data.map((country: Country) => ({
      label: country.attributes.name,
      value: country.attributes.name,
      code: country.attributes.code2,
    }));
    return {
      ...state,
      countries: {
        data: beautifyCountries,
        paging,
        meta,
      },
    };
  }),
]);

export default countryInformationRegionsReducer;
